import React, {Component} from "react";
import {connect} from "react-redux";
import * as actions from "../../actions/index";
import moment from "moment";

import AvailabilityModal from "../../components/modal/AvailabilityDetails";
import {isEmpty, navigate, showModal, vuepayAlert, vuePayLog} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import {
    getAvailabilityRequestsGroup,
    getAvailabilityRequestsOneToOne,
    subscribeToFireStore,
    unsubscribeToFireStore,
} from "../../util/firebase/firestore";
import {getEncryptedIdForBroadcaster} from "../../util/broadcast_util";

const screename = "BroadcastAvailability";
class BroadcastAvailability extends Component {
    constructor() {
        super();

        this.state = {
            groupRequests: 0,
            oneToOneRequests: 0,
            oneToOneRequestList: [],
            groupRequestList: [],
            isSubscribed: true,
            isFetching: false,
            activeTab: '1'
        };

        //all the functions used in this component should be listed here for better documentation
    }

    componentDidMount() {
        this.props.showLeftBar(); //hide the leftbar
        window.scrollTo(0, 0);
    }

    getAvailabilityPresent = (state) => {
        if (state.account_management.userDetails &&
            state.account_management.userDetails.hasOwnProperty("broadcaster") &&
            Array.isArray(state.account_management.userDetails.broadcaster) &&
            state.account_management.userDetails.broadcaster.length > 0 &&
            state.account_management.userDetails.broadcaster[0].hasOwnProperty("availability") &&
            Array.isArray(state.account_management.userDetails.broadcaster[0].availability) &&
            state.account_management.userDetails.broadcaster[0].availability.length > 0 &&
            state.account_management.userDetails.broadcaster[0].availability[0]) {
            return state.account_management.userDetails.broadcaster[0].availability[0];
        } else {
            return {};
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        // handle request to get all availability
        if (nextProps.availability &&
            nextProps.availability.isSuccess &&
            nextProps.availability.availabilityRequestsList &&
            nextProps.availability.availabilityRequestsList.success.status_code == 200
        ) {

            const broadcastID = getEncryptedIdForBroadcaster(this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast[0].id);

            this.setState({isFetching:false});
            this.props.history.push("/broadcaster/availability/requests?broadcast_id=" + broadcastID, {
                activeTab: this.state.activeTab
            });
            this.props.resetGetAllRequestForBroadcast();
        } else if (
            nextProps.availability &&
            nextProps.availability.isError &&
            nextProps.availability.availabilityRequestsList
        ) {
            vuepayAlert(
                "error",
                nextProps.availability.availabilityRequestsList.response.error.message
            );
            this.props.resetGetAllRequestForBroadcast();
        }

        if(this.state.isSubscribed){
            const hasAvailability = this.props.account_management &&
                this.props.account_management.hasOwnProperty("userDetails") &&
                this.props.account_management.userDetails &&
                this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
                Array.isArray(this.props.account_management.userDetails.broadcaster) &&
                this.props.account_management.userDetails.broadcaster.length > 0 &&
                this.props.account_management.userDetails.broadcaster[0].hasOwnProperty("availability") &&
                Array.isArray(this.props.account_management.userDetails.broadcaster[0].availability) &&
                this.props.account_management.userDetails.broadcaster[0].availability.length > 0 &&
                this.props.account_management.userDetails.broadcaster[0].availability[0].hasOwnProperty("broadcast") &&
                Array.isArray(this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast) &&
                this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast.length > 0;

            if(hasAvailability){
                let broadcastId = this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast[0].id;
                subscribeToFireStore(
                    broadcastId.toString(),
                    this.onGroupRequestUpdate,
                    this.onOneToOneRequestUpdate
                );

                this.setState({
                    isSubscribed: false
                })
            }
        }
    }

    componentWillUnmount() {
        let availability = this.getAvailabilityPresent(this.props);
        if(availability.hasOwnProperty("broadcast")){
            let broadcastId = availability.broadcast[0].id;
            unsubscribeToFireStore(broadcastId.toString())
        }
    }

    onOneToOneRequestUpdate = (querySnapshot) => {
        vuePayLog(screename, "onOneToOneRequestUpdate");
        let oneToOneRequest = [];
        querySnapshot.forEach((doc) => {
            if (doc.exists && doc.data().status === 0) {
                oneToOneRequest.push(doc.data());
            }
        });

        this.setState({
            oneToOneRequestList: oneToOneRequest,
        },()=>{
            vuePayLog(screename,"onOneToOneRequestUpdate >> oneToOneRequestList",this.state.oneToOneRequestList)
        });
        this.props.updateOneToOneAvailabilityList(oneToOneRequest);
    };

    privateSessionUpdate = (querySnapshot) => {
        vuePayLog(screename,"privateSessionUpdate");
        let privateRequest = [];
        querySnapshot.forEach((doc) => {
            privateRequest.push(doc.data());
        });
        vuePayLog(screename,"privateSessionUpdate >> privateRequest",privateRequest);
        this.props.updatePrivateAvailabilityList(privateRequest);
    };

    onGroupRequestUpdate = (querySnapshot) => {
        vuePayLog(screename,"onGroupRequestUpdate");
        let groupRequest = [];
        querySnapshot.forEach((doc) => {
            if (doc.exists && doc.data().status === 0) {
                groupRequest.push(doc.data());
            }
        });

        this.setState({
            groupRequestList: groupRequest,
        },()=>{
            vuePayLog(screename,"onGroupRequestUpdate >> groupRequestList",this.state.groupRequestList)
        });
        this.props.updateGroupAvailabilityList(groupRequest);
    };

    checkBroadcasterAvialability = () => {
        return (
            this.props.account_management.userDetails &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0
        );
    };

    getAvailabilityDuration = () => {
        let startTime =
            this.checkBroadcasterAvialability() &&
            this.props.account_management.userDetails &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .availability_start_at;

        let endTime =
            this.checkBroadcasterAvialability() &&
            this.props.account_management.userDetails &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .availability_end_at;

        let time = moment.utc(startTime).local().format("hh:mm a") +
            " - " +
            moment.utc(endTime).local().format("hh:mm a");
        return time;
    };

    showBroadcasterDetailModal = () => {
        const modal = document.getElementById("availability-description");
        showModal(modal);
    };

    redirectToGoliveOrAvailability = (availabilityFlag) => {
        navigate(
            this.props,
            availabilityFlag
                ? this.checkBroadcasterAvialability()
                ? this.showBroadcasterDetailModal()
                : "broadcaster_create_availability"
                : "broadcaster_create_broadcast"
        );
    };


    redirectToMyLibrary = ()=>{
        this.props.history.push("/broadcaster/my-library");
    }

    setActiveTab = (activeTab) => {
        this.setState({
            activeTab
        },()=>{
            this.retrieveAllAvailability();
        })
    };

    // Get All Request for Broadcast
    retrieveAllAvailability = () => {

        this.setState({
            isFetching:true
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.checkBroadcasterAvialability(
                    this.props.account_management.userDetails
                ) &&
                this.props.getAllRequestForBroadcast(
                    data.token,
                    data.api_token,
                    this.checkBroadcasterAvialability() &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].broadcast[0].id
                );
            }
        });
    };

    getRequestsData = () => {
        getAvailabilityRequestsGroup(
            this.checkBroadcasterAvialability() &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .broadcast[0].id,
            (jsonData) => {
                this.setState({
                    groupRequests: jsonData && jsonData,
                });
            }
        );
        getAvailabilityRequestsOneToOne(
            this.checkBroadcasterAvialability() &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .broadcast[0].id,
            (jsonData) => {
                this.setState({
                    oneToOneRequests: jsonData && jsonData,
                });
            }
        );
    };

    getNumberOfcount = (requestList) => {
        let countData = requestList.filter((request) => {
            return request.status == 0;
        });
        return countData.length;
    };

    render() {
        /**
         * TODO
         * update the Left bar to show broadcaster related menu
         */
        const {handleSubmit} = this.props;
        const isBroadcasterAvailable = this.checkBroadcasterAvialability();

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container broadcast-type">
                            <p className="select-an-option-to">Select an option to go!</p>

                            <div className="wrapper" style={{padding: "3rem 8rem"}}>

                                <div onClick={() => this.redirectToGoliveOrAvailability(false)}
                                     className="row rectangle"
                                     style={{marginBottom: 32}}>

                                    <div className="col-sm-3 goLive"></div>
                                    <div className="col-sm-9 data-container">
                                        <p className="title-content">GO LIVE NOW!</p>
                                        <p className="subtitle-content">
                                            Broadcast LIVE, build your audience and accept paid group or
                                            one on one requests at the touch of a button
                                        </p>
                                    </div>
                                </div>
                                <div onClick={() => this.redirectToGoliveOrAvailability(true)}
                                     className="row rectangle">
                                    <div className={
                                        isBroadcasterAvailable
                                            ? "col-sm-3 availability-live"
                                            : "col-sm-3 availability"
                                    }
                                    />
                                    <div className="col-sm-9 data-container">
                                        <p className="title-content">
                                            {isBroadcasterAvailable
                                                ? "You’re Available!"
                                                : "Set your availability"}
                                        </p>
                                        {
                                            isBroadcasterAvailable
                                                ?
                                                <p className="subtitle-content">
                                                    You have set your availability <span
                                                    className="subtitle-content-bold">{this.getAvailabilityDuration()}</span>.<br/> You
                                                    can view, edit or cancel your availability.Also, view, accept or
                                                    decline user’s requests. Please click to view all details.
                                                </p>
                                                :
                                                <p className="subtitle-content">
                                                    Broadcast LIVE, build your audience and accept paid group or one to
                                                    one request at the touch of the button
                                                </p>
                                        }

                                    </div>
                                </div>

                                <div onClick={() => this.redirectToMyLibrary()}
                                     className="row rectangle"
                                     style={{marginTop: 32}}>

                                    <div className="col-sm-3 myLibrary"></div>
                                    <div className="col-sm-9 data-container">
                                        <p className="title-content">Upload content</p>
                                        <p className="subtitle-content">
                                            Upload and share your content either for free or for a fee
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </main>

                <AvailabilityModal
                    getAllRequestForBroadcast={this.retrieveAllAvailability}
                    isFetching={this.state.isFetching}
                    availabilityData={
                        isBroadcasterAvailable &&
                        this.props.account_management.userDetails.broadcaster[0]
                            .availability[0]
                    }
                    // groupRequests={
                    //     this.props.availability &&
                    //     this.props.availability.groupAvailabilityList
                    // }
                    // oneToOneRequests={
                    //     this.props.availability &&
                    //     this.props.availability.oneToOneAvailabilityList
                    // }
                    groupRequests={this.state.groupRequestList}
                    oneToOneRequests={this.state.oneToOneRequestList}
                    setActiveTab={this.setActiveTab}
                    getNumberOfcount={this.getNumberOfcount}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        availability: state.availability,
    };
}

export default connect(mapStateToProps, actions)(BroadcastAvailability);
